import _defineProperty from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var i = function i(_i, e) {
    return "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? _objectSpread(_objectSpread({}, e), {}, {
      finisher: function finisher(n) {
        n.createProperty(e.key, _i);
      }
    }) : {
      kind: "field",
      key: Symbol(),
      placement: "own",
      descriptor: {},
      originalKey: e.key,
      initializer: function initializer() {
        "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
      },
      finisher: function finisher(n) {
        n.createProperty(e.key, _i);
      }
    };
  },
  e = function e(i, _e, n) {
    _e.constructor.createProperty(n, i);
  };
function n(n) {
  return function (t, o) {
    return void 0 !== o ? e(n, t, o) : i(n, t);
  };
}
export { n as property };